import { Layout } from "antd";

const { Footer } = Layout;

export const CustomFooter = () => {

  return (
    <Footer
      style={{
        backgroundColor: "#fafafa",
        borderTop: "1px solid #f0f0f0",
        paddingTop: "40px",
        paddingBottom: "0",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>
        {/* Main footer content */}
        <div
          className="footer-main-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "200px 1fr",
            marginBottom: "10px",
          }}
        >
            {/* Logo */}
            <img src="/assets/pWinLogo.svg" alt="pWin" height={36} />
        </div>

        <div
          className="footer-bottom-flex"
          style={{
            paddingTop: "40px",
            paddingBottom: "40px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <span style={{ color: "#999", fontSize: "14px" }}>
            ©2025 Paramify, Inc. All Rights Reserved
          </span>
          <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
            <a
              href="https://www.paramify.com/legal/terms-and-conditions"
              style={{
                color: "#999",
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              Terms
            </a>
            <a
              href="https://www.paramify.com/legal/privacy-policy"
              style={{
                color: "#999",
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              Privacy
            </a>
            <a
              href="https://www.paramify.com/legal/cookie-policy"
              style={{
                color: "#999",
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              Cookies
            </a>
            <a
              href="https://www.paramify.com/legal/data-processing-agreement"
              style={{
                color: "#999",
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              Data Processing
            </a>
            <a
              href="https://www.paramify.com/legal/access-and-services-agreement"
              style={{
                color: "#999",
                fontSize: "14px",
                textDecoration: "none",
              }}
            >
              Platform Agreement
            </a>
          </div>
        </div>
      </div>
      {/* Responsive CSS for stacking footer on small screens */}
      <style>{`
        @media (max-width: 1000px) {
          .footer-main-grid {
            display: flex !important;
            flex-direction: column !important;
            gap: 48px !important;
          }
          .footer-links-grid {
            display: flex !important;
            flex-direction: column !important;
            gap: 32px !important;
          }
          .footer-bottom-flex {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 24px !important;
          }
        }
      `}</style>
    </Footer>
  );
};
